<template>
    <v-card :color="backgroundColor" height="120px" outlined style="border-color: gray; border-width: 3px">
        <v-card-text no-gutters class="pt-0">
            <v-row dense no-gutters class="pt-2">
                <v-col cols="12" class="nameLabelCard ml-0">
                    {{ placement.seafarer.name }} {{ placement.seafarer.surname }}
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="dateLabelCard"> {{ dateLabel }}&nbsp;{{ displayDate }} </v-col>
            </v-row>
            <v-row align="center" no-gutters class="mt-1">
                <v-col v-if="showCheckbox" cols="auto" class="pa-0">
                    <CheckBox v-model="placement.selected" @click.native.prevent="handleCheckbox" />
                </v-col>

                <v-col class="rankLabelCard pt-2">
                    {{ placement.rank.abbreviation }}
                </v-col>

                <v-col cols="auto" class="text-right pt-2">
                    <v-icon
                        small
                        :color="showPending && placement.pending_action ? 'red' : undefined"
                        @click="handleOpen"
                    >
                        fas fa-info-circle
                    </v-icon>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import CheckBox from './trinkets/CheckBox';

export default {
    name: 'PlacementCard',
    components: {CheckBox},
    props: {
        placement: {type: Object, required: true},
        dateLabel: {type: String, required: true},
        /** Which key on placement holds the display date. Defaults to start_date. */
        dateField: {type: String, default: 'start_date'},
        showCheckbox: {type: Boolean, default: false},
        showPending: {type: Boolean, default: false},
        backgroundColor: {type: String, default: '#FFFFFF'},
    },
    computed: {
        displayDate() {
            return this.placement[this.dateField];
        },
    },
    methods: {
        handleCheckbox() {
            this.$emit('toggle-select', this.placement);
        },
        handleOpen() {
            this.$emit('open', this.placement.id);
        },
    },
};
</script>
<style scoped>
html {
    overflow: hidden !important;
}

.v-card {
    display: flex !important;
    flex-direction: column;
}

.v-card__text {
    flex-grow: 1;
    overflow: auto;
}

.collTitle {
    font-size: 1.1em;
    padding-top: 7px;
    padding-bottom: 7px;
}

.nameLabelCard {
    font-size: 1.2em;
    font-weight: bold;
    padding-bottom: 0;
    padding-left: 0;
}

.dateLabelCard {
    padding: 0 0 0 7px;
    font-size: 0.9em;
}

.rankLabelCard {
    font-size: 0.9em;
    padding: 0;
    display: flex;
    align-items: center;
}
</style>
